import { QueryFunctionContext } from '@tanstack/react-query';

import { request } from '@request';

import { StripePricingResponse } from '../types/pricing';
import { URL_API_BASE } from '.';

/**
 * Fetch all pricing plans from backend, which fetches live data from Stripe API
 * and maps it to our frontend format.
 */
export async function getAllPricingPlans(args?: QueryFunctionContext): Promise<StripePricingResponse> {
  const res = await request.get(`${URL_API_BASE}/pricing/plans`, { signal: args?.signal });
  return res.data as StripePricingResponse;
}

/**
 * Fetch pricing for a specific price ID
 */
export async function getPriceById(priceId: string, args?: QueryFunctionContext): Promise<StripePricingResponse['plans'][0]> {
  const res = await request.get(`${URL_API_BASE}/pricing/price/${priceId}`, { signal: args?.signal });
  return res.data as StripePricingResponse['plans'][0];
}
